import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
var _excluded = ["src", "placeholder", "bgColor", "isDark", "alt", "observerProps", "imgClassName", "className", "size", "href", "aProps", "isLazy", "css", "htmlProps"];
import { useMemo } from 'react';
import cn from 'classnames';
import getSizeCss from "../helpers/getSizeCss";
import LazyImage from "../LazyImage";
import LazyImageResponsive from "../LazyImage/LazyImageResponsive";
import { AVATAR } from "./classnames";
import { getAvatarSrc } from "./utils";
import { jsx as _jsx } from "react/jsx-runtime";
var Avatar = function Avatar(_ref) {
  var srcProp = _ref.src,
    placeholder = _ref.placeholder,
    bgColor = _ref.bgColor,
    isDark = _ref.isDark,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? 'avatar' : _ref$alt,
    observerProps = _ref.observerProps,
    imgClassNameProp = _ref.imgClassName,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 40 : _ref$size,
    href = _ref.href,
    aProps = _ref.aProps,
    _ref$isLazy = _ref.isLazy,
    isLazy = _ref$isLazy === void 0 ? true : _ref$isLazy,
    css = _ref.css,
    htmlProps = _ref.htmlProps,
    avatarProps = _objectWithoutProperties(_ref, _excluded);
  var _useMemo = useMemo(function () {
      return getAvatarSrc({
        src: srcProp,
        size: size
      });
    }, [srcProp, size]),
    src = _useMemo.src,
    sources = _useMemo.sources;
  var sizeCss = useMemo(function () {
    return getSizeCss(size);
  }, [size]);
  var defaultBackgroundColorClassName = isDark ? 'bg-gray-main-dark-mode' : 'bg-gray-lighter';
  var imgClassName = cn('w-full h-full', bgColor ? "bg-".concat(bgColor) : defaultBackgroundColorClassName, imgClassNameProp);
  var emptySource = /*#__PURE__*/_jsx("div", {
    className: imgClassName
  });
  var responsiveLazy = sources ? /*#__PURE__*/_jsx(LazyImageResponsive, {
    className: imgClassName,
    imgClassName: "object-cover",
    placeholder: placeholder,
    sources: sources,
    alt: alt,
    observerProps: observerProps,
    isDark: isDark
  }) : emptySource;
  var simpleLazy = src ? /*#__PURE__*/_jsx(LazyImage, {
    className: imgClassName,
    imgClassName: "object-cover",
    placeholder: placeholder,
    src: src,
    alt: alt,
    observerProps: observerProps,
    isDark: isDark
  }) : emptySource;
  var lazy = sources ? responsiveLazy : simpleLazy;
  var img = src ? /*#__PURE__*/_jsx("img", {
    className: imgClassName,
    style: {
      objectFit: 'cover'
    },
    src: src,
    alt: alt
  }) : emptySource;
  if (href) {
    return /*#__PURE__*/_jsx(_StyledA, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      className: cn(AVATAR, className),
      href: href
    }, aProps), avatarProps), htmlProps), {}, {
      $_css: sizeCss,
      $_css2: css,
      children: isLazy ? lazy : img
    }));
  }
  return /*#__PURE__*/_jsx(_StyledDiv, _objectSpread(_objectSpread(_objectSpread({
    className: cn(AVATAR, className)
  }, avatarProps), htmlProps), {}, {
    $_css3: sizeCss,
    $_css4: css,
    children: isLazy ? lazy : img
  }));
};
export default Avatar;
var _StyledA = /*#__PURE__*/_styled("a")(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["\n          ", "\n          ", "\n        "])), function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
});
var _StyledDiv = /*#__PURE__*/_styled2("div").withConfig({
  componentId: "sc-10gqvq2-0"
})(["\n        ", "\n        ", "\n      "], function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
});